var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEmployee({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(-24 -152)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_202",
    "data-name": "Rectangle 202",
    width: 48,
    height: 48,
    transform: "translate(24 152)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_employee_deactive",
    transform: "translate(40 166.362)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10643",
    "data-name": "Group 10643"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M16.136,592.357v-2.636a3.472,3.472,0,0,0-3.472-3.471H4.892a3.472,3.472,0,0,0-3.472,3.471v2.636",
    transform: "translate(-1.42 -574.444)",
    fill: "none",
    stroke: "#767493",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 4.027,
    cy: 4.027,
    r: 4.027,
    transform: "translate(3.331 0)",
    fill: "none",
    stroke: "#767493",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M23.58,566.05a4.027,4.027,0,0,1,0,8.054",
    transform: "translate(-10.629 -566.05)",
    fill: "none",
    stroke: "#767493",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M30.47,585.3s3.711.836,3.156,6.668",
    transform: "translate(-13.492 -574.05)",
    fill: "none",
    stroke: "#767493",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmployee);
export default __webpack_public_path__ + "static/media/icon_employee.251e2682ea8879b273fc00b9fb8d0bfe.svg";
export { ForwardRef as ReactComponent };